import { render, staticRenderFns } from "./CalendarRealEdit.vue?vue&type=template&id=922d3da2&"
import script from "./CalendarRealEdit.vue?vue&type=script&lang=js&"
export * from "./CalendarRealEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports